module.exports = __webpack_public_path__ + "img/身份证背面.c4e4cb01.png";